import * as React from "react";
import { Layout } from "antd";
import styled from "styled-components";
import { AppSidebar, Boundary, Loading, NavigationMenu, useElementSize, useNavigation, } from "..";
const Container = styled.div `
  background: white;
  width: 100%;
  min-height: 100%;

  padding: ${(p) => (p.padding ? "24px" : "0")};
`;
const Sidebar = styled.div ``;
const Content = styled.div ``;
export const AdminLayout = React.memo(function AdminLayout({ children, contentPadding = false, siderStyle, loading, contentWidth, footerChildren, }) {
    var _a;
    const { width } = useElementSize({ current: (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.body }, 100);
    const [groups, items, activeItems] = useNavigation("sidebar");
    const isMobile = width < 1200;
    if (isMobile) {
        return (React.createElement(Container, { padding: contentPadding },
            React.createElement(AppSidebar, null),
            React.createElement(Boundary, null, children)));
    }
    return (React.createElement(Layout, { style: { background: "rgb(240, 242, 245)", overflow: "hidden" } },
        isMobile && React.createElement(AppSidebar, null),
        !isMobile && (groups.length > 0 || items.length > 0) ? (React.createElement(Layout.Sider, { width: 300, style: Object.assign({ background: "#fff" }, siderStyle) },
            React.createElement(NavigationMenu, { style: { height: "100%" } }))) : null,
        React.createElement(Layout, { style: { overflow: "auto" } },
            React.createElement(Layout.Content, { style: {
                    margin: "24px",
                    width: contentWidth ? contentWidth : "auto",
                } }, loading ? React.createElement(Loading, { message: "" }) : React.createElement(Boundary, null, children)),
            footerChildren ? (React.createElement(Layout.Footer, { style: { margin: "24px", background: "#fff" }, children: footerChildren })) : undefined)));
});
//# sourceMappingURL=AdminLayout.js.map